angular
  .module('GlobalControllers')

  .controller('PasswordResetCtrl', [
    '$scope',
    '$http',
    'API_URL',
    'EXAM',
    function($scope, $http, API_URL, EXAM) {
      $scope.data = {};

      $scope.passwordReset = function() {
        $scope.data.success = $scope.data.fail = false;

        $http
          .post(API_URL + '/ask_password_reset' + '?exam=' + EXAM, {
            email: $scope.data.username
          })
          .success(function(data) {
            $scope.data.result = data;
            $scope.data.success = true;
          })
          .error(function(data) {
            $scope.data.result = data;
            $scope.data.fail = true;
          });
      };
    }
  ])

  .controller('PasswordResetValidationCtrl', [
    '$scope',
    '$http',
    'API_URL',
    '$routeParams',
    '$location',
    'EXAM',
    function($scope, $http, API_URL, $routeParams, $location, EXAM) {
      $scope.data = {};
      $scope.loading = true;

      var reset_code = $routeParams.reset_code;

      if (reset_code) {
        passwordReset();
      } else {
        $location.url('/');
      }

      function passwordReset() {
        $scope.data.success = $scope.data.fail = false;

        $http
          .post(API_URL + '/password_reset' + '?exam=' + EXAM, {
            reset_code: reset_code
          })
          .success(function(data) {
            $scope.loading = false;
            $scope.data.result = data;
            $scope.data.success = true;
          })
          .error(function(data) {
            $scope.loading = false;
            $scope.data.result = data;
            $scope.data.fail = true;
          });
      }
    }
  ])

  .component('passwordEdit', {
    templateUrl: '/ng1/www/modules/global/password/html/edit.html',
    controller: [
      '$scope',
      'api',
      'navbar',
      '$location',
      '$mdToast',
      '$translate',
      function($scope, api, navbar, $location, $mdToast, $translate) {
        $scope.data = {};

        // navbar.goBackAction("Accueil", "#!/");

        $scope.passwordEdit = function() {
          delete $scope.error;
          delete $scope.success;

          if ($scope.data.password1 === $scope.data.password2) {
            api
              .changePassword($scope.data.old_password, $scope.data.password1)
              .then(
                function(response) {
                  $scope.success = 'Votre mot de passe a été mis à jour';
                  console.log($scope.main);
                  api
                    .login(api.data.me.user.username, $scope.data.password1)
                    .then(function(data) {
                      $location.url('/');
                    });
                },
                function(response) {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        $translate.instant('toasts.incorrect_password')[
                          'toasts.incorrect_password'
                        ]
                      )
                      .position('bottom right')
                  );
                }
              );
          } else {
            $scope.error = 'Vos mots de passe ne sont pas identiques';
          }
        };
      }
    ]
  });
